import React from "react";
import {Route, useLocation} from "react-router-dom";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {InfoCard} from "../components/InfoCard";


// Routes fulfilled by this component
const fpRoutes = ['/startup', '/cashin', '/sellout'];
export const isFourPointPlanLocation = pathname => fpRoutes.find(route => pathname.startsWith(route))
export const getFourPointPlanRoutes = () => fpRoutes.map((route, idx) =>
  <Route path={route} key={idx} component={ViewFourPointPlan}/>);


const useLocalStyles = makeStyles(() => ({
  infoCard: {
    background: '#efe8ed',
  },
}));

const NumberBullet = ({number}) => <span style={{color: "#E21"}}>{number}.&nbsp;</span>

const Point = ({selected, number, link, children}) => {
  const contents = link ? <a href={link} style={{textDecoration: 'none'}}>{children}</a> : <span>{children}</span>;
  if (selected)
    return <h1>➸&nbsp;<NumberBullet number={number}/>{contents}</h1>;
  return <h2><NumberBullet number={number}/>{contents}</h2>;
}

export function ViewFourPointPlan() {
  const classes = useLocalStyles();
  const location = useLocation();
  const locMatch = expected => location.pathname === expected;
  return (
    <div style={{textAlign: "center"}}>
      <Container maxWidth="sm">
        <InfoCard title={<h3><u>4 Point Plan</u></h3>} className={classes.infoCard}>
          <Point number="1" selected={locMatch('/startup')} link="/startup">Start Up</Point>
          <Point number="2" selected={locMatch('/cashin')} link="/cashin">Cash In</Point>
          <Point number="3" selected={locMatch('/sellout')} link="/sellout">Sell Out</Point>
          <Point number="4" selected={locMatch('/brodown')} link="/brodown">Bro Down</Point>
        </InfoCard>
      </Container>
    </div>
  );
}
